// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import api from '../../services/api';
// import { getMediaUrl } from '../../services/api';
// import './DepartmentsSection.css';

// const DepartmentsSection = ({ section }) => {
//   const [departments, setDepartments] = useState([]);

//   useEffect(() => {
//     loadDepartments();
//   }, []);

//   const loadDepartments = async () => {
//     try {
//       const response = await api.get('/departments/', { params: { page_size: 6 } });
//       setDepartments(response.data.results || response.data);
//     } catch (error) {
//       console.error('Error loading departments:', error);
//     }
//   };

//   if (departments.length === 0) return null;

//   return (
//     <section className="departments-section homepage-section">
//       <Container>
//         <h2 className="section-title">{section.title}</h2>
//         <Row>
//           {departments.map(dept => (
//             <Col key={dept.id} md={4} sm={6} className="mb-4">
//               <Card className="department-card h-100">
//                 {dept.image && (
//                   <Card.Img 
//                     variant="top" 
//                     src={getMediaUrl(dept.image)} 
//                     alt={dept.name}
//                   />
//                 )}
//                 <Card.Body>
//                   <Card.Title>
//                     <Link to={`/departments/${dept.slug}`}>{dept.name}</Link>
//                   </Card.Title>
//                   <Card.Text className="small">
//                     <strong>Head:</strong> {dept.head_officer}
//                   </Card.Text>
//                   <Link to={`/departments/${dept.slug}`} className="btn btn-outline-primary btn-sm">
//                     View Details
//                   </Link>
//                 </Card.Body>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//         <div className="text-center mt-4">
//           <Link to="/departments" className="btn btn-primary">View All Departments</Link>
//         </div>
//       </Container>
//     </section>
//   );
// };

// export default DepartmentsSection;




import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { getMediaUrl } from '../../services/api';
import './DepartmentsSection.css';

const DepartmentsSection = ({ section }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      const response = await api.get('/departments/', { params: { page_size: 6 } });
      const deptData = response.data.results || response.data;
      setDepartments(Array.isArray(deptData) ? deptData : []);
    } catch (error) {
      console.error('Error loading departments:', error);
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="departments-section homepage-section">
        <Container>
          <h2 className="section-title">{section.title}</h2>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (departments.length === 0) return null;

  return (
    <section className="departments-section homepage-section">
      <Container>
        <h2 className="section-title">{section.title}</h2>
        <Row className={departments.length < 3 ? 'justify-content-center' : ''}>
          {departments.map(dept => (
            <Col key={dept.id} lg={4} md={6} sm={12} className="d-flex">
              <Card className="department-card">
                {dept.image && (
                  <Card.Img 
                    variant="top" 
                    src={getMediaUrl(dept.image)} 
                    alt={dept.name}
                  />
                )}
                <Card.Body>
                  <Card.Title>
                    <Link to={`/departments/${dept.slug}`}>{dept.name}</Link>
                  </Card.Title>
                  <Card.Text>
                    <strong>Head:</strong> {dept.head_officer}
                  </Card.Text>
                  <Link to={`/departments/${dept.slug}`} className="btn btn-outline-primary btn-sm">
                    View Details <i className="fas fa-arrow-right ms-1"></i>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-4">
          <Link to="/departments" className="btn btn-primary">
            View All Departments <i className="fas fa-arrow-right ms-2"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default DepartmentsSection;

